import React from 'react';
import { styled } from '@mui/material';
import CourtesyPage from './CourtesyPage';
import passwordExpired from '../assets/images/password_expired.svg';
import Column from 'src/frontend-common/components/Column';
import { CustomButton } from '../forms/styledFormComponents';
import FidoLogo from 'src/frontend-common/components/Logo';
import { useNavigate } from 'react-router-dom';

interface PasswordExpiredProps {
  onBackToLogin?: () => void;
}

const Container = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(5),
  width: '50%',
  alignSelf: 'center',
  [theme.breakpoints.up('xl')]: {
    maxWidth: '50%',
    padding: theme.spacing(15),
  },
}));

const PasswordExpired: React.FC<PasswordExpiredProps> = ({ onBackToLogin }) => {
  const navigate = useNavigate();
  return (
    <Container>
      <div style={{ marginBottom: 50 }}>
        <FidoLogo />
      </div>
      <CourtesyPage
        title="Password expired"
        content="Your password has expired. For security reasons we have sent you a temporary password by email. Please log in again with your temporary password."
        image={{ src: passwordExpired, alt: 'Password expired!' }}
      >
        <Column centered>
          <CustomButton
            variant="contained"
            style={{ backgroundColor: 'black', color: 'white' }}
            disableElevation
            onClick={onBackToLogin ? onBackToLogin : () => navigate('/login')}
          >
            Back to login
          </CustomButton>
        </Column>
      </CourtesyPage>
    </Container>
  );
};
export default PasswordExpired;
